import React from 'react';
import { Coins } from 'lucide-react';
import { Badge } from './ui/badge';

// Presentational points-history (ledger) section extracted from AccountSettings
// to keep that component smaller. Receives all data/helpers via props so it
// stays stateless and easy to test.
export const PointsHistorySection = ({ user, ledger, ledgerLabel, fmtDate, t }) => {
  if (!user) return null;
  return (
    <div className="space-y-2 rounded-lg border p-3" data-testid="account-points-history">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <Coins className="h-4 w-4 text-primary" />
          <span className="text-sm font-medium">{t('Punkte-Verlauf', 'Points history')}</span>
        </div>
        <Badge variant="secondary" data-testid="account-points-balance">
          {user?.points_unlimited ? t('Unbegrenzt', 'Unlimited') : `${user?.points ?? 0} ${t('Punkte', 'points')}`}
        </Badge>
      </div>
      {ledger.length === 0 ? (
        <p className="py-1 text-xs text-muted-foreground" data-testid="account-points-empty">
          {t('Noch keine Punkte-Bewegungen.', 'No points activity yet.')}
        </p>
      ) : (
        <ul className="divide-y divide-border" data-testid="account-points-list">
          {ledger.map((e) => (
            <li key={e.id} className="flex items-center justify-between gap-2 py-2 text-sm" data-testid={`points-item-${e.id}`}>
              <div className="min-w-0">
                <div className="truncate font-medium">{ledgerLabel(e.reason)}</div>
                <span className="text-xs text-muted-foreground">{fmtDate(e.created_at)}</span>
              </div>
              <div className="text-right">
                <div className={`font-medium tabular-nums ${e.delta > 0 ? 'text-emerald-600' : (e.delta < 0 ? 'text-destructive' : 'text-muted-foreground')}`}>
                  {e.unlimited ? '∞' : (e.delta > 0 ? `+${e.delta}` : e.delta)}
                </div>
                {e.balance_after != null && !e.unlimited && (
                  <span className="text-xs text-muted-foreground">{t('Rest', 'Bal.')}: {e.balance_after}</span>
                )}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
